import styled, { css } from "styled-components";
import { media } from "../styles/media"; // 생성한 미디어 쿼리 헬퍼 가져오기
import { Modal } from 'react-bootstrap';

////////////////////////////////////////////////////////////
// 태블릿용 그리드 UI
// 2개의 탭을 한 줄에 배치하기 위한 컨테이너 
export const MainContainer = styled.div`
    // display: inline-flex;
    display: flex;
    flex-direction: column;
    align-items: center;
    // gap: 30px;
`;

export const TabGridContainer = styled.div`
    display: grid;
    gap: 14px;

    justify-items: center; /* 가운데 정렬 */
    grid-template-columns: repeat(3, 1fr);
`;

/////////////////////////////////////////////////////


/******************************************************************/
/********************* 각 백그라운드, 타이틀********************/
/******************************************************************/

// 디바이스 백그라운드
export const DeviceArea = styled.div`

    /* 🔑 핵심: 자식 배치를 위한 기준점 설정 */
    position: relative;     

    /* 🔑 Flexbox를 사용해 내부 요소 배치 */
    display: flex;
    flex-direction: column; /* 세로 방향으로 요소 배치 */
    align-items: center; /* 가운데 정렬 */


    width: 330px;
    // height: 550px;
    height: 60vh;

    padding: 20px;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;

    border-radius: 8px;
    border: 1px solid var(--Grayscale-GR_F1, #F1F1F1);
    background: var(--Grayscale-WT_FF, #FFF);    

    /* 태블릿 배치 */
    ${media.tablet`
        width: 310px;
        height: 600px;
        padding: 24px;
        gap: 28px;
        border-radius: 24px;
    `}

    /* Desktop 배치 */
    ${media.desktop`
        width: 450px;          
        height: 700px;
    `}     
     
`;

export const DeviceTitle = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 12px;
    align-self: stretch;
    justify-content: center;

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}        
`;

// only tablet, desktop
// 각 메뉴 공통 타이틀 텍스트
export const DeviceTitleText = styled.span`
    display: flex;
    height: 44px;
    // flex-direction: column;
    justify-content: center;
    flex: 1 0 0;

    overflow: hidden;
    color: var(--Grayscale-BK_00, #000);
    text-overflow: ellipsis;
    white-space: nowrap;

    /* tablet/H3 */
    font-family: Roboto;
    font-size: 26px;
    font-style: normal;
    font-weight: 500;
    line-height: 36px; /* 112.5% */

    /* 🔑 절대 배치 유지 */
    // position: absolute;     

    /* 🔑 부모(DeviceArea) 기준 위치 설정 */
    // top: calc(24/393 * 100%);
    // left: calc(105/328 * 100%);

    /* 태블릿 배치 */
    ${media.tablet`
        font-size: 18px;
        line-height: 26px; /* 116.667% */

        /* 1. position 속성 해제 (absolute -> static 또는 relative) */
        position: static; 
        
        /* 2. top/left 속성 해제 */
        top: initial;
        left: initial;
        /* 또는 top: unset; left: unset; 도 사용 가능합니다. */  
    `}

    /* 데스크톱 배치 */
    ${media.desktop`
        font-size: 24px;
        line-height: 28px; /* 116.667% */

        /* 1. position 속성 해제 (absolute -> static 또는 relative) */
        position: static; 
        
        /* 2. top/left 속성 해제 */
        top: initial;
        left: initial;
        /* 또는 top: unset; left: unset; 도 사용 가능합니다. */  
    `}

`;

// 디바이스 우측 상단 버튼
export const DeviceButton = styled.button`

    display: flex;
    height: 44px;
    min-width: 72px;
    padding: 12px;
    justify-content: center;
    align-items: center;
    gap: 10px;

    // position: absolute;
    /* 🔑 부모(DeviceArea) 기준 위치 설정 */
    // top: calc(24/600 * 100%);
    // right: calc(20/310 * 100%);
       
    border-radius: 8px;
    background: var(--NeonGreen, #85F2A6);

    color: var(--DarkNavy, #1B1F38);
    text-align: center;

    /* tablet/body1_B */
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 120% */

    /* 태블릿 배치 */
    ${media.tablet`
        font-size: 14px;
    `}

    /* Desktop 배치 */
    ${media.desktop`
        font-size: 20px;
    `}
`;

// 디바이스 우측 상단 그래프 버튼
export const GraphButton = styled.button`

    display: flex;
    height: 44px;
    min-width: 72px;
    padding: 12px;
    justify-content: center;
    align-items: center;
    gap: 10px;

    // position: absolute;
    /* 🔑 부모(DeviceArea) 기준 위치 설정 */
    // top: calc(24/600 * 100%);
    // right: calc(110/310 * 100%);
       
    border-radius: 8px;
    background: var(--NeonGreen, #85c1f2ff);

    color: var(--DarkNavy, #1B1F38);
    text-align: center;

    /* tablet/body1_B */
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 120% */

    /* 태블릿 배치 */
    ${media.tablet`
        font-size: 14px;
    `}

    /* Desktop 배치 */
    ${media.desktop`
        font-size: 20px;
    `}
`;

// 디바이스 정보 테이블
export const DeviceInfoTable = styled.div`

    display: grid;
    width: 100%;
    height: 470px;
    column-gap: 12px;
    flex-shrink: 0;
    grid-template-rows: repeat(17, minmax(0, 1fr));
    grid-template-columns: repeat(1, minmax(0, 1fr));

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}
`;

// 디바이스 정보 Tr
export const DeviceInfoTableTr = styled.div`
    display: flex;

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}
`;

// 디바이스 정보 Row
export const DeviceInfoTableRow = styled.div`

    display: flex;
    padding: 5px 0;
    align-items: center;
    gap: 4px;
    flex: 1 0 0;
    align-self: stretch;
    // grid-row: 1 / span 1;
    grid-column: 1 / span 1;

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}
`;

// 디바이스 정보 Row 제목
export const DeviceInfoTableRowInfoTitle = styled.label`

    color: var(--Grayscale-GR_66, #666);

    /* 🌟 핵심 추가 🌟 */
    flex-grow: 1; /* 남은 공간을 최대한 채움 */
    text-align: right; /* 내용을 오른쪽으로 정렬하여 콜론에 붙임 */

    /* tablet/body2_R */
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 125% */

    /* 태블릿 배치 */
    ${media.tablet`
        font-size: 14px;
    `}

    /* Desktop 배치 */
    ${media.desktop`
        font-size: 18px;
    `}
`;

// 디바이스 정보 중간 기준
export const DeviceInfoTableRowInfoCenter = styled.label`

    color: var(--Grayscale-GR_66, #666);

    /* 🌟 핵심 추가 🌟 */
    flex-shrink: 0; /* 공간이 부족해도 줄어들지 않음 */
    width: auto; /* 내용물 크기만큼만 차지 */

    /* tablet/body2_R */
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 125% */

    /* 태블릿 배치 */
    ${media.tablet`
        font-size: 14px;
    `}

    /* Desktop 배치 */
    ${media.desktop`
        font-size: 18px;
    `}
`;

// 디바이스 정보 Row 내용
export const DeviceInfoTableRowInfoText = styled.label`

    color: var(--Grayscale-BK_00, #000);

    /* 🌟 핵심 추가 🌟 */
    flex-grow: 1; /* 남은 공간을 최대한 채움 */
    text-align: left; /* 내용을 왼쪽으로 정렬하여 콜론에 붙임 */

    /* tablet/body1_M */
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 120% */

    /* 태블릿 배치 */
    ${media.tablet`
        font-size: 16px;
    `}

    /* Desktop 배치 */
    ${media.desktop`
        font-size: 24px;
    `}
`;

// 디바이스 정보 하단 라인
export const DeviceInfoTabLine = styled.div`
    /* 모바일 기본 */
    width: 250px;
    height: 0.5px;
    flex-shrink: 0;

    background: var(--Grayscale-BK_00, #000);

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}    
`;


// 디바이스 페이지 프레임
export const DevicePageFrame = styled.div`

    display: inline-flex;
    justify-content: center;
    align-items: center;

    // position: absolute;
    /* 🔑 부모(DeviceArea) 기준 위치 설정 */
    // top: 45vh;
    // left: 2vw;

    /* 태블릿 배치 */
    ${media.tablet`
        // top:  70vh;
        // bottom: 40vh;
        // left: calc(98/310 * 100%);
    `}

    /* Desktop 배치 */
    ${media.desktop`
        // bottom: calc(-900/600 * 100%);
        // left: calc(115/310 * 100%);
    `}
`;

// 디바이스 페이지
export const DevicePageNum = styled.div`

    display: flex;
    width: 50px;
    height: 50px;
    padding: 13px 0;
    justify-content: center;
    align-items: center;
    aspect-ratio: 1/1;

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}
`;

// 디바이스 페이지 버튼
export const DevicePageButton = styled.button`

    display: flex;
    width: 100px;
    height: 50px;
    padding: 13px 0;
    justify-content: center;
    align-items: center;
    aspect-ratio: 1/1;

    border-radius: 8px;
    background-color: var(--Blue, #85F2A6);

    text-align: center;

    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 120% */

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}
`;

// 디바이스 페이지 텍스트
export const DevicePageIcon = styled.span<{$imgUrl: string;}>`

    width: 20px;
    height: 20px;
    flex-shrink: 0;

    background: none;
    border: none;
    background-image: url(${(props) => props.$imgUrl}); 
    background-repeat: no-repeat;
    background-size: contain; /* 또는 cover, 100% auto 등 */  
    
    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}
`;

// 디바이스 페이지 텍스트 프레임
export const DevicePageNumTextFrame = styled.div`

    display: flex;
    width: 150px;
    padding: 30px;
    justify-content: center;
    align-items: center;
    aspect-ratio: 1/1;

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}
`;

// 디바이스 페이지 텍스트
export const DevicePageNumText = styled.span`

    color: var(--Grayscale-BK_00, #000);
    text-align: center;

    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 120% */

    /* 태블릿 배치 */
    ${media.tablet`

    `}

    /* Desktop 배치 */
    ${media.desktop`

    `}
`;


// 디바이스 탭 충/방전 그래프 모달 커스텀
export const CustomSizeModal = styled(Modal)`
  .modal-dialog {
    max-width: 800px;
    width: 90%;
    // max-height: 1000px;
    // height: 100%;
  }

  /* 2. 탭 색상 변경: .modal-body와 .nav-tabs를 모두 사용하여 우선순위 극대화 */
  .modal-body .nav-tabs .nav-link.active {
      background-color: #007bff !important; /* 배경색: 파란색 */
      color: white !important; /* 글자색: 흰색 */
      border-color: #dee2e6 #dee2e6 #007bff !important;
  }
  
  .modal-body .nav-tabs .nav-link {
      color: #495057 !important; /* 글자색: 회색 */
  }

`;